import { Box, Card, CardActions, CardContent, CardHeader, Divider, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import MultiCheckbox from './MultiCheckbox'
import { useTranslation } from 'react-i18next'
import { LoadingButton } from '@mui/lab'
import { ROLES } from 'src/constants'

export default function MerchantRoleAndDeliveryMethods({
    profile,
    loading,
    error,
    isSuccess,
    onUpdate
}) {
    const { t } = useTranslation()
    const [deliveryMethod, setSelectedDeliveryMethod] = useState([])
    const [role, setRole] = useState("")

    useEffect(() => {
        setSelectedDeliveryMethod(profile?.deliveryMethod)
        setRole(profile?.role)
    }, [profile])

    const onSubmit = () => {
        if (role === "SHIPPING_COMPANY") {
            onUpdate({ role })
        } else {
            onUpdate({ deliveryMethod, role })
        }
    }

    const disable = () => {
        if (profile?.role === ROLES.shippingCompany) return !role
        if (profile?.merchant?.role === ROLES.merchant) return deliveryMethod?.length === 0 || !role
    }

    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <CardHeader title={t("Account Type")} />
            <Divider />
            <CardContent sx={{ flex: 1 }}>
                <Stack spacing={2}>
                    <FormControl size="small" fullWidth>
                        <InputLabel id="role-select-label">{t("Role")}</InputLabel>
                        <Select
                            name="role"
                            labelId="role-select-label"
                            id="role-select"
                            value={role || ""}
                            label={t("Role")}
                            MenuProps={{ disableScrollLock: true }}
                            onChange={({ target: { value } }) => setRole(value)}
                        >
                            <MenuItem value={'SHIPPING_COMPANY'}>{t("A Shipping Company")}</MenuItem>
                            <MenuItem value={'BASIC'}>{t("A Merchant")}</MenuItem>
                        </Select>
                    </FormControl>
                    {profile?.role === ROLES.merchant &&
                        <MultiCheckbox
                            name="deliveryMethod"
                            value={deliveryMethod || []}
                            options={
                                [
                                    { id: "MYSELF", label: t("Deliver to yourself") },
                                    { id: "MAPIT_SHIP", label: t("Delivery by Mapit Ship") }
                                ]
                            }
                            onChange={({ target: { value } }) => setSelectedDeliveryMethod(value)}
                            label={''}
                            formGroupProps={{ row: true }}
                            labelProps={{ sx: { fontWeight: "bold" } }}
                        />
                    }
                </Stack>
            </CardContent>
            <Divider />
            <CardActions>
                {!!error && <Typography color="error">{t(error)}</Typography>}
                {isSuccess && <Typography color="green.main">{t("Done successfully")}</Typography>}
                <Box mr="auto" />
                <LoadingButton
                    onClick={onSubmit}
                    loading={loading}
                    variant="contained"
                    sx={{ textTransform: "none" }}
                    disabled={disable()}
                >
                    {t("Confirm")}
                </LoadingButton>
            </CardActions>
        </Card>
    )
}
